module.exports = __webpack_public_path__ + "img/lordsmobile-guide.36ea2aa.jpg";